import $ from 'jquery'

$(document).on('click', '.course-nav-module-header', function (e) {
  const $module = $(this).parents('.course-nav-module')
  $module.toggleClass('course-nav-module--open')
  $(this).attr('aria-expanded', $module.hasClass('course-nav-module--open'))
  // Don't want to trigger this event and the one below as well.
  return false
})

$(document).on(
  'click',
  '.course-nav-module:not(.course-nav-module--open)',
  function (e) {
    $(this).toggleClass('course-nav-module--open')
    $(this)
      .find('.course-nav-module-header')
      .attr('aria-expanded', $(this).hasClass('course-nav-module--open'))
    return false
  }
)

$(document).on('click', '.course-navigation-toggle__item', function (e) {
  $('.course-tabblable > *').addClass('course-tabbable--inactive')
  $($(this).data('show')).removeClass('course-tabbable--inactive')

  $('.course-navigation-toggle__item--active').removeClass(
    'course-navigation-toggle__item--active'
  )
  $(this).addClass('course-navigation-toggle__item--active')

  // Scroll back to top of the section so that scrolling one doesn't seem to affect the other.
  if (
    $(document).scrollTop() > $('.course-navigation-toggle').data('static-top')
  ) {
    $(document).scrollTop(
      $('.course-navigation-toggle').data('static-top') -
        $('.site-header').height()
    )
  }

  if ($(this).data('show') === '#course-nav-container') {
    return window.scrollTo(
      0,
      $('.course-nav-lesson--active').offset().top - 350
    )
  }
})

// Simulate position: sticky for course navigation on mobile.
$(document).scroll(function (e) {
  // Avoid doing this if we're not on a course page, or we're not showing the tabbed nav.
  let static_top
  const courseNav = $('.course-navigation-toggle')
  if (courseNav.length === 0 || courseNav.css('display') === 'none') {
    return
  }

  // Remember the position of it in its normal case.
  if (courseNav.data('static-top')) {
    static_top = courseNav.data('static-top')
  } else {
    static_top = courseNav.offset().top
    courseNav.data('static-top', static_top)
  }

  // This will fill in the space left by changing courseNav to position: fixed, to avoid the page jumping.
  const courseNavSpace = $('.course-navigation-toggle-spacer')

  const fixed_header_height = $('body.sticky-header .site-header').height() || 0 //+ $(".site-header").offset().top
  // Has the element scrolled off screen (or under the header)?
  if ($(document).scrollTop() + fixed_header_height > static_top) {
    if (courseNav.css('position') !== 'fixed') {
      courseNavSpace.css({ height: courseNav.height(), display: 'block' })
      return courseNav.css({
        position: 'fixed',
        top: fixed_header_height + 'px',
        width: '100%',
      })
    }
  } else if (courseNav.css('position') === 'fixed') {
    courseNavSpace.css({ display: 'none' })
    return courseNav.css({ position: 'static', width: 'auto' })
  }
})

//# Browser support for position: sticky is still very yucky for old browsers
// The below simulates that
//  initializeStickyCourseNav - Called on document.ready and window.resize
//   -> decides if we want to update the position of the nav (if on desktop)
//   -> or just reset everything and stop (if on mobile - since the behavior we want on mobile is different)
//  updateStickyCourseNav - does the actual position updating
//
// We also don't do the switching using css classes because it's possible someone has modified their theme.scss.liquid file
//
const initializeStickyCourseNav = function () {
  resetStickyCourseNav()
  if ($('.course-navigation-toggle').css('display') !== 'none') {
    return
  }

  $('#course-nav-container')
    .data('static-width', $('#course-nav-container').outerWidth())
    .css({ 'max-height': '88vh', overflow: 'auto' })
    .addClass('better-webkit-scrollbar')
  $('#course-lesson-container').addClass('lg--right')
  updateStickyCourseNav()
  return $(window).scroll(updateStickyCourseNav)
}

var resetStickyCourseNav = function () {
  $('#course-nav-container')
    .data('static-width', '')
    .css({ 'max-height': '', overflow: '', float: '', position: '', width: '' })
    .removeClass('better-webkit-scrollbar')
  $('#course-lesson-container').removeClass('lg--right')
  return $(window).off('scroll', updateStickyCourseNav)
}

var updateStickyCourseNav = function () {
  const courseNavContainer = $('#course-nav-container')
  const courseLessonContainer = $('#course-lesson-container')
  const courseLessonContainerTop = courseLessonContainer.offset().top
  const courseNavContainerHeight = courseNavContainer.height()
  const courseNavContainerWidth = courseNavContainer.data('static-width')

  const windowTop = $(window).scrollTop()
  const footerTop = $('footer.site-footer').offset().top

  const padding = 30

  if (courseLessonContainer.height() < courseNavContainerHeight) {
    courseLessonContainer.css('min-height', courseNavContainerHeight)
  }

  if (windowTop + courseNavContainerHeight + padding > footerTop - padding) {
    return courseNavContainer.css({
      top: (windowTop + courseNavContainerHeight - footerTop + padding) * -1,
    })
  } else if (windowTop > courseLessonContainerTop - padding) {
    return courseNavContainer.css({
      float: 'left',
      position: 'fixed',
      top: padding,
      width: courseNavContainerWidth,
    })
  } else {
    return courseNavContainer.css({ float: '', position: '', width: '' })
  }
}

$(initializeStickyCourseNav)
$(window).resize(initializeStickyCourseNav)

// auto scroll to the selecting module/lesson
$(function () {
  const courseNavContainer = $('#course-nav-container')
  if (
    courseNavContainer.length &&
    $("div[data-show='#course-nav-container']:visible").length === 0
  ) {
    return courseNavContainer.animate(
      { scrollTop: $('.course-nav-lesson--active').offset().top - 350 },
      1000
    )
  }
})
